/**
 * For some reason gomus~events/tours always have the startTime 00:00:00.
 * If we set the initial date to eg. 12:34:11, all dates on that day would be filtered out.
 * @returns {Date} currentDate at 00:00:00
 */
export default function getStartDate() {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
}
